import { render, staticRenderFns } from "./UserColumn.vue?vue&type=template&id=b8848e1e&scoped=true&"
import script from "./UserColumn.vue?vue&type=script&lang=js&"
export * from "./UserColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8848e1e",
  null
  
)

export default component.exports